import Section from './Section.vue'

export const redEnvelopeRainModule = {
  type: 2,
  component: Section,
  reset(localForm, ctx) {
    const { buildDefaultRedTiers, redRuleFlags, redRuleValues } = ctx
    localForm.redTiers = buildDefaultRedTiers()
    redRuleFlags.bet = false
    redRuleFlags.payin = false
    redRuleValues.today_bet_amount = undefined
    redRuleValues.today_payin_amount = undefined
    redRuleValues.count_limit = 0
    redRuleValues.countdown = 0
    redRuleValues.duration = 0
    redRuleValues.multiple = 0
  },
  fillFromActivity(localForm, raw, ctx) {
    const {
      centsToYuanNumber,
      normalizeRedTierForForm,
      createDefaultRedGuaranteeTier,
      buildDefaultRedTiers,
      redRuleFlags,
      redRuleValues,
    } = ctx

    const cfg = raw.gold_rain_config || raw.config || {}
    const rule = cfg.rule && typeof cfg.rule === 'object' ? cfg.rule : {}

    redRuleFlags.bet = rule.today_bet_amount != null && Number(rule.today_bet_amount) > 0
    redRuleFlags.payin = rule.today_payin_amount != null && Number(rule.today_payin_amount) > 0

    redRuleValues.today_bet_amount = redRuleFlags.bet ? centsToYuanNumber(rule.today_bet_amount) : 0
    redRuleValues.today_payin_amount = redRuleFlags.payin ? centsToYuanNumber(rule.today_payin_amount) : 0

    redRuleValues.count_limit = Number(rule.count_limit) >= 0 ? Number(rule.count_limit) : 0
    redRuleValues.countdown = Number(rule.countdown) >= 0 ? Number(rule.countdown) : 0
    redRuleValues.duration = Number(rule.duration) >= 0 ? Number(rule.duration) : 0
    redRuleValues.multiple = Number(rule.multiple) >= 0 ? Number(rule.multiple) : 0

    if (Array.isArray(cfg.vips)) {
      localForm.vips = cfg.vips.map(v => Number(v)).filter(v => Number.isFinite(v))
    }

    const rawTiers = Array.isArray(cfg.tiers) ? cfg.tiers : []
    if (rawTiers.length > 0) {
      const normalized = rawTiers.map(normalizeRedTierForForm)
      const guarantee =
        normalized.find(t => Number(t.reward_type) === 3 || t.isGuarantee) || createDefaultRedGuaranteeTier()
      const others = normalized.filter(t => Number(t.reward_type) !== 3 && !t.isGuarantee)
      guarantee.isGuarantee = true
      guarantee.reward_type = 3
      guarantee.weight = 0
      guarantee.total_unlimited = true
      guarantee.total = 0
      localForm.redTiers = [...others, guarantee]
    } else {
      localForm.redTiers = buildDefaultRedTiers()
    }
  },
  validate(localForm, ctx) {
    const {
      Message,
      RED_NUM_INTERVAL_GTE,
      RED_NUM_INTERVAL_GT,
      RED_REWARD_TYPE_RANDOM,
      RED_REWARD_TYPE_FIXED,
      RED_REWARD_TYPE_GUARANTEE,
    } = ctx

    if (!Array.isArray(localForm.redTiers) || localForm.redTiers.length === 0) {
      Message.error('请先配置红包奖池')
      return false
    }

    const guarantee = localForm.redTiers.find(t => Number(t.reward_type) === RED_REWARD_TYPE_GUARANTEE || t.isGuarantee)
    if (!guarantee) {
      Message.error('请包含保底奖励配置')
      return false
    }

    for (let i = 0; i < localForm.redTiers.length; i += 1) {
      const t = localForm.redTiers[i]
      const rowIndex = i + 1
      if (!t) continue

      if (Number(t.reward_type) === RED_REWARD_TYPE_GUARANTEE || t.isGuarantee) {
        const rc = Number(t.reward_count)
        if (!Number.isFinite(rc) || rc <= 0) {
          Message.error(`红包保底奖励（第${rowIndex}行）奖励数须大于0`)
          return false
        }
        continue
      }

      const numInterval = Number(t.num_interval_type)
      if (!(numInterval === RED_NUM_INTERVAL_GTE || numInterval === RED_NUM_INTERVAL_GT)) {
        Message.error(`红包区间条件（第${rowIndex}行）请重新选择`)
        return false
      }
      const num = Number(t.num)
      if (!Number.isFinite(num) || num <= 0) {
        Message.error(`红包区间条件（第${rowIndex}行）个数须大于0`)
        return false
      }

      const rt = Number(t.reward_type)
      if (rt === RED_REWARD_TYPE_RANDOM) {
        const min = Number(t.reward_count_min)
        const max = Number(t.reward_count_max)
        if (!Number.isFinite(min) || min < 0 || !Number.isFinite(max) || max < 0) {
          Message.error(`随机奖励（第${rowIndex}行）奖励区间须填写合法数字`)
          return false
        }
        if (max < min) {
          Message.error(`随机奖励（第${rowIndex}行）上限须大于等于下限`)
          return false
        }
      } else if (rt === RED_REWARD_TYPE_FIXED) {
        const rc = Number(t.reward_count)
        if (!Number.isFinite(rc) || rc <= 0) {
          Message.error(`固定奖励（第${rowIndex}行）奖励数须大于0`)
          return false
        }
      } else {
        Message.error(`奖励类型（第${rowIndex}行）请选择随机/固定`)
        return false
      }

      if (!t.total_unlimited) {
        const total = Number(t.total)
        if (!Number.isFinite(total) || total < 0) {
          Message.error(`初始库存（第${rowIndex}行）须为非负数或选择无限库存`)
          return false
        }
      }
    }
    return true
  },
  buildPayload(localForm, ctx) {
    const { buildRedRulePayload, buildRedTiersPayload } = ctx
    return {
      gold_rain_config: {
        rule: buildRedRulePayload(),
        vips: [...localForm.vips].sort((a, b) => a - b),
        tiers: buildRedTiersPayload(),
      },
    }
  },
}

